import fetch from 'cross-fetch';
import API from './../actions/actions'

export const apiMiddleware = ({dispatch}) => next => action => {
    if (action.type !== 'API') {
        return next(action)
    }
    const {payload} = action
    dispatch({ type: payload.PENDING })

    fetch.get(payload.url)
        .then(response => {
            dispatch({ type: payload.SUCCESS, payload: response.data })
        })
        .catch(err => {
            dispatch({ type: payload.FAILURE })
        })
}



// WEBPACK FOOTER //
// ./assets/src/js/middleware/api.js